export default __webpack_public_path__ + "static/stellantis-43879a374072a778fefefc25e423b97f.mp4";